import { Box, Grid, Typography } from '@mui/material';
import { videoUrls, videoTitles } from '../../../constants/Common';
import Card from '@mui/material/Card';

function DemoVideoList() {
  return (
    <Box display="flex" alignItems="center" flexDirection="column">
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {videoUrls.map((url, index) => (
            <Box key={index} mb={2} display="flex" justifyContent="center">
              <iframe
                width="300"
                height="200"
                src={url}
                title={`Demo Video ${index + 1}`}
                allowFullScreen
                style={{ border: 0 }}
              />
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} md={6}>
          {videoTitles.map((title, index) => (
            <Box key={index} mb={2} display="flex" justifyContent="center">
              <Card sx={{mt:"15px", mb:"35px",height: "150px", width: "400px", borderRadius: "10px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="subtitle1" align="center">
                  <strong>{`${index + 1}. ${title}`}</strong>
                </Typography>
              </Card>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}

export default DemoVideoList;
